<template>
  <div class="page-opportunities-form" v-loading.fullscreen="loading" id="top">
    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-main">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <el-button class="inline-middle is-gap-large-top"
            v-if="isDevOrLocal"
            type="info" @click="onFill" style="margin-left:15px;" size="mini">
            Auto Fill (Debug)
          </el-button>

          <div class="section-form">
            <formm
              ref="form"
              :form="form"
              :rules="formRules"
              :columns="formColumns"
              :data="formData"
              @on-select-changed="onFormSelectChange">
            </formm>
          </div>

        </div>
      </div>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-upload">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="section-form">

            <!-- <h1>Upload Resume</h1>
            <hr /> -->

            <formm
              ref="formResume"
              fname="formResume"
              :form="formResume"
              :rules="formResumeRules"
              :columns="formResumeColumns"
              :data="formData"
              @on-file-preview="onFilePreview"
              @on-file-exceed="onFileExceed"
              @on-file-change="onFileChange"
              @on-file-success="onFileSuccess">
            </formm>

            <!-- <div>
              {{ JSON.stringify(formResume) }}
            </div> -->

            <el-button class="button color-green-bg"
              v-if="isDevOrLocal"
              @click="testUpload"
              :disabled="!formResume || !formResume.files || formResume.files.length <= 0">
              Test Upload
            </el-button>

          </div>
        </div>
      </div>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-ref">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="section-form">

            <!-- <h1>References</h1>
            <hr /> -->
            <p>Please list 3 references with Name, Title, email, and phone number.</p>

            <div class="is-gap-large-top is-gap-large-bottom"
              v-for="(formRef, findex) in formRefs" :key="`${findex}`"
              style="position:relative;">

              <div class="is-gap" style="margin-bottom:18px;">
                <p><b>Reference {{ findex + 1 }}</b></p>
              </div>
              <!-- <hr v-if="parseInt(findex, 10) !== 0" class="is-gap-large-bottom" /> -->

              <formm
                ref="formRef"
                :form="formRef"
                :findex="findex"
                :rules="formRefRules"
                :columns="formRefColumns"
                :data="formData">
              </formm>

              <!-- <div>
                <el-button icon="el-icon-close"
                  class="button color-white-bg"
                  :style="(isDesktop ? {
                    position: 'absolute',
                    right: '26%',
                    top: 0,
                  } : {})"
                  v-if="formRefs.length > 1"
                  @click="onRemoveReference(parseInt(findex, 10))">
                </el-button>
              </div> -->
            </div>

            <!-- <el-button class="button color-green-bg"
              @click="onAddReference" v-if="!formRefs || formRefs.length < 3">
              Add More Reference
            </el-button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-ref">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="section-form">

            <!-- <h1>Licenses</h1>
            <hr /> -->
            <p>Please upload the following required licenses for this position.</p>

            <div class="is-gap-large-top is-gap-large-bottom"
              v-for="(formLicense, lindex) in formLicenses" :key="`${lindex}`"
              style="position:relative;">

              <div class="is-gap" style="margin-bottom:18px;">
                <p><b>License {{ lindex + 1 }}</b></p>
              </div>
              <!-- <hr v-if="parseInt(findex, 10) !== 0" class="is-gap-large-bottom" /> -->

              <formm
                ref="formLicenses"
                fname="formLicenses"
                :form="formLicense"
                :findex="lindex"
                :rules="formLicensesRules"
                :columns="formLicense.columns"
                :data="formData"
                @on-file-preview="onFilePreview"
                @on-file-exceed="onFileExceed"
                @on-file-change="onFileChange"
                @on-file-success="onFileSuccess">
              </formm>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container is-gap-large-top is-gap-large-bottom" data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="section-form" style="margin-top:0;">
            <el-button class="button color-green-bg"
              @click="onSubmit">
              Submit Application
            </el-button>

            <div v-if="error != null"
              class="column is-full label"
              style="color:#F56C6C;font-size:12px;">
              {{ error }}
            </div>

            <div v-if="isValidateError"
              class="column is-full label"
              style="color:#F56C6C;font-size:12px;">
              * Form contains error, please kindly recheck.
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
import OpeningFormConstants from '@/pages/opportunities/formopening/formconstants'
import Util from '@/util'
import StringUtil from '@/util/string'
import FileUtil from '@/util/file'
import EventBus from '@/controllers/EventBus'
// import Site from '@/apis/site'
import SiteAims from '@/apis/aims'

// import InfoBlock from '@/pages/base/infoblock'
import Formm from '@/base/form'

import File from '@/apis/file'
// import Upload from '@/apis/upload'

const getUploadColumnsWithLabel = (label) => {
  let cols = _.cloneDeep(OpeningFormConstants.FormUpload.COLUMNS)
  let col = _.find(cols, (col) => col.type === 'upload')
  if (col) {
    col.label = label
  }
  return cols
}

export default {
  name: 'page-opportunities-form',
  props: {
    // msg: String
    dataJob: {},
  },
  components: {
    // InfoBlock,
    Formm,
  },
  data () {
    return {
      name: 'form-opening',
      loading: false,
      isDesktop: true,
      isDevOrLocal: (Constants.isDev || Constants.isLocalhost),
      isMounted: false,
      jobId: (this.$route.params.jobId && parseInt(this.$route.params.jobId, 10)),
      // dataJob: {},
      blocks: [],
      // form
      form: {},
      formRules: OpeningFormConstants.Form.getValidators(this, {
        isRelocate: false,
        isProvidedService: false
      }),
      formColumns: OpeningFormConstants.Form.COLUMNS,
      formData: {
        dataSelectYesNo: Constants.OPTIONS_YES_NO,
        optionsState: []
      },
      // form refs
      formRefs: [{}],
      formRefRules: OpeningFormConstants.FormRef.getValidators(this),
      formRefColumns: OpeningFormConstants.FormRef.COLUMNS,
      // form upload
      formResume: {
        files: [],
      },
      formResumeRules: OpeningFormConstants.FormResume.getValidators(this, {}),
      formResumeColumns: getUploadColumnsWithLabel('Resume').concat(OpeningFormConstants.FormResume.COLUMNS),
      // form licenses
      formLicenses: [],
      formLicenseColumns: OpeningFormConstants.FormUpload.COLUMNS,
      formLicensesRules: OpeningFormConstants.FormUpload.getValidators(this, {}),
      // validator
      error: undefined,
      isValidateError: false,
      validateErrorSection: undefined,
    }
  },
  computed: {
    Util: function () {
      return Util
    },

    isRelocate: function () {
      return this.form.isRelocate === Constants.OptionsYesNo.YES
    },

    isProvidedService: function () {
      return this.form.isProvidedService === Constants.OptionsYesNo.YES
    },
  },
  watch: {
    'dataJob': function () {
      this.loadData(this.dataJob)
    },

    'form.isRelocate': function () {
      OpeningFormConstants.Form.updateEnablers(this, this.formColumns, this.form)
      this.setRules()
    },

    'form.isProvidedService': function () {
      OpeningFormConstants.Form.updateEnablers(this, this.formColumns, this.form)
      this.setRules()
    },
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.clear()
    this.setRules()

    this.load()
    this.loadData(this.dataJob)
    await this.refresh()

    this.$set(this, 'isMounted', true)
  },
  methods: {
    clear () {
      let keyinfos = OpeningFormConstants.Form.KEYS
      let form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'form', form)

      keyinfos = OpeningFormConstants.FormRef.KEYS
      form = Util.request.getDefaults(keyinfos)
      form.keys = keyinfos
      this.$set(this, 'formRefs', [
        _.cloneDeep(form),
        _.cloneDeep(form),
        _.cloneDeep(form),
      ])

      keyinfos = OpeningFormConstants.FormResume.KEYS
      form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'formResume', form)
    },

    load () {
      // this.$set(this.form, '')
      if (this.$route.query.field) {
        this.$set(this.form, 'field', this.$route.query.field)
      }

      let states = Util.common.states()
      states = _.map(states, (item) => {
        return {
          id: item,
          label: item
        }
      })
      this.$set(this.formData, 'optionsState', states)
    },

    loadData (data) {
      if (!data || data.certificates == null || data.certificates.length <= 0) {
        this.$set(this, 'formLicenses', [])
        return
      }

      let certs = data.certificates || []
      certs = _.map(certs, (cert) => {
        return {
          ...cert,
          columns: getUploadColumnsWithLabel(cert.name),
          files: [],
        }
      })
      this.$set(this, 'formLicenses', certs)
    },

    setRules () {
      let params = {
        isRelocate: this.isRelocate,
        isProvidedService: this.isProvidedService,
      }
      let rules = OpeningFormConstants.Form.getValidators(this, params)
      this.$set(this, 'formRules', rules)

      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) {
          this.$refs.form.clearValidate()
        }

        for (let f in this.$refs.formRef) {
          let formRef = this.$refs.formRef[f]
          if (formRef && formRef.clearValidate) {
            formRef.clearValidate()
          }
        }
      })
    },

    async refresh () {
      try {
        this.$set(this, 'error', undefined)
        this.$set(this, 'loading', true)
        // data
        let promises = []
        let promise
        // promise = this.getJob()
        // promises.push(promise)
        promise = this.getCountries()
        promises.push(promise)
        await Promise.all(promises)
        // post
        promises = []
        promise = this.getStates()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    // async getJob () {
    //   let response = await SiteAims.getJob(this.$route.params.jobId)
    //   let data = (response && response.data) || {}
    //   this.$set(this, 'dataJob', data)

    //   if (!data || data.certificates == null || data.certificates.length <= 0) {
    //     this.$set(this, 'formLicenses', [])
    //     return
    //   }

    //   let certs = data.certificates || []
    //   certs = _.map(certs, (cert) => {
    //     return {
    //       ...cert,
    //       columns: getUploadColumnsWithLabel(cert.name),
    //       files: [],
    //     }
    //   })
    //   this.$set(this, 'formLicenses', certs)
    // },

    async getCountries () {
      let response = await SiteAims.getNominalData('countries')
      let data = (response && response.data) || []
      data = _.map(data, (item) => {
        return {
          id: item.id,
          label: item.name,
        }
      })
      this.$set(this.formData, 'dataCountries', data)
      let country = _.find(data, (item) => item.label && item.label.toLowerCase().includes('united'))
      if (country) {
        this.$set(this.form, 'countryId', country.id)
      }
    },

    async getStates () {
      let countryId = this.form && this.form.countryId
      if (countryId == null || `${countryId}`.length <= 0) {
        this.$set(this.form, 'stateId', undefined)
        return
      }
      let params = {
        countryId,
      }
      let response = await SiteAims.getNominalData('states', params)
      let data = (response && response.data) || []
      data = _.map(data, (item) => {
        return {
          id: item.id,
          label: item.name,
        }
      })
      this.$set(this.formData, 'dataStates', data)
    },

    onFill () {
      let keyinfos = OpeningFormConstants.Form.KEYS_FILL
      let form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'form', form)

      keyinfos = OpeningFormConstants.FormResume.KEYS_FILL
      form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'formResume', form)

      for (let f in this.formRefs) {
        // let fNo = parseInt(f, 10) + 1
        // let formRef = this.formRefs[f]
        let keyinfos = OpeningFormConstants.FormRef.KEYS_FILL
        // keyinfos = OpeningFormConstants.FormRef.KEYS
        let form = Util.request.getDefaults(keyinfos)
        _.map(form, (value, key) => {
          if (key === 'name' || key === 'relationship') {
            value = `${value} ${f + 1}`
          }
          this.$set(this.formRefs[f], key, value)
        })
      }
    },

    // onAddReference () {
    //   if (!this.formRefs) this.$set(this, 'formRefs', [])

    //   // let nextIndex = (this.formRefs.length + 1)
    //   let keyinfos = OpeningFormConstants.FormRef.KEYS
    //   let form = Util.request.getDefaults(keyinfos)
    //   form.keys = keyinfos
    //   this.formRefs.push(form)
    // },

    // onRemoveReference (index) {
    //   this.formRefs.splice(index, 1)
    // },

    // on form

    async onFormSelectChange (info) {
      if (!this.isMounted || this.loading) return
      const name = info && info.name
      switch (name) {
        case 'countryId':
          // this.form.stateId = null
          this.$set(this.form, 'stateId', undefined)
          this.$set(this, 'loading', true)
          await this.getStates()
          this.$set(this, 'loading', false)
          break
        default:
          break
      }
    },

    // on file

    async onFilePreview (info) {
      // console.log('onFilePreview', info)
      if (info && info.file && info.file.url) {
        // window.open(info.file.url, '_blank')
        try {
          this.loading = true
          await File.download(info.file.url)
          this.loading = false
        } catch (error) {
          this.loading = false
          console.error('file download failed', error)
          // this.$message({
          //   message: `File download failed: ${error.message || error}`,
          //   type: 'error'
          // })
        }
      }
    },

    onFileExceed (info) {
      this.$message({
        message: `Files exceeded total limit (${info.fileList ? info.fileList.length : -1}).`,
        type: 'error'
      })
    },

    onFileChange (info) {
      this.cleartoleave = false
      console.log(`${this.name}: form file change`, info)

      // form
      let form = this.form
      if (info.fname && this[info.fname]) {
        form = this[info.fname]
      }

      let refForm = this.$refs.form
      if (info.fname && this.$refs[info.fname]) {
        refForm = this.$refs[info.fname]
      }

      let findex = info.findex
      if (typeof findex === 'number') {
        // form
        if (!Array.isArray(form) || findex >= form.length) {
          console.error('invalid file change form array')
          return
        }
        form = form[findex]

        // refForm
        if (!Array.isArray(refForm) || findex >= refForm.length) {
          console.error('invalid file change refForm array')
          return
        }
        refForm = refForm[findex]
      }

      if (form && info.field && info.fileList) {
        // console.log(`${this.name}: upload form set`, { field: info.field, fileList: info.fileList })
        this.$set(form, info.field, info.fileList)
      }

      if (refForm && info.field && refForm.validateField) {
        refForm.validateField(info.field)
      }
    },

    onFileSuccess (info) {
      // this.$refs.form.validateField()
    },

    // validate / submit

    async validate () {
      let isValidateError = false
      this.validateErrorSection = undefined
      try {
        if (this.$refs.form && this.$refs.form.validate) {
          await this.$refs.form.validate()
        }
      } catch (error) {
        if (error !== false) throw error
        isValidateError = true
        if (!this.validateErrorSection) {
          this.validateErrorSection = 'main'
        }
      }

      if (this.$refs.formRef) {
        let formRefs = this.$refs.formRef
        if (typeof formRefs !== 'object') throw new Error('invalid form ref object')
        if (!Array.isArray(formRefs)) formRefs = [formRefs]
        for (let f in formRefs) {
          let formRef = formRefs[f]
          try {
            if (formRef && formRef.validate) {
              await formRef.validate()
            }
          } catch (error) {
            if (error !== false) throw error
            isValidateError = true
            if (!this.validateErrorSection) {
              this.validateErrorSection = 'ref'
            }
          }
        }
      }

      try {
        if (this.$refs.formResume && this.$refs.formResume.validate) {
          await this.$refs.formResume.validate()
        }
      } catch (error) {
        if (error !== false) throw error
        isValidateError = true
        if (!this.validateErrorSection) {
          this.validateErrorSection = 'upload'
        }
      }

      if (this.$refs.formLicenses) {
        let formLicenses = this.$refs.formLicenses
        if (typeof formLicenses !== 'object') throw new Error('invalid form license object')
        if (!Array.isArray(formLicenses)) formLicenses = [formLicenses]
        for (let f in formLicenses) {
          let formLicense = formLicenses[f]
          try {
            if (formLicense && formLicense.validate) {
              await formLicense.validate()
            }
          } catch (error) {
            if (error !== false) throw error
            isValidateError = true
            if (!this.validateErrorSection) {
              this.validateErrorSection = 'license'
            }
          }
        }
      }

      if (isValidateError) {
        let returnFalse = false
        throw returnFalse
      }
    },

    async testUpload () {
      console.log(`${this.name}: testUpload`)
      try {
        this.loading = true
        await this.uploadFile('formResume', -1, Constants.UploadFileType.APPLICANT_RESUME)
        this.$alert('Uploaded successfully.', {
          type: 'success'
        })
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$message({
          message: `Upload failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async uploadFile (field, findex, type = Constants.UploadFileType.UNKNOWN) {
      let form = this.form
      switch (field) {
        case 'formResume':
          form = this.formResume
          break
        case 'formLicenses':
          form = this.formLicenses[findex]
          break
        default:
          throw new Error('invalid form for upload')
      }
      if (!form) {
        throw new Error('invalid form')
      }

      let files = form.files
      if (!files || files.length <= 0) throw new Error('invalid files')
      let file = files[0]
      // console.log(`${this.name}: uploading - ${field} form...`, form)
      // console.log(`${this.name}: uploading - ${field}...`, file)

      let id = file.uid
      if (id == null || id.length <= 0) {
        id = `${StringUtil.random(13, '0123456789')}`
      }
      const indata = {
        id,
        type,
        fileindex: 0,
        fileName: file.name,
      }
      if (file.hasOwnProperty('url')) { // had alredy been uploaded for first time
        return file
      }

      // const formData = new FormData()
      // for (var i = 0; i < files.length; i++) {
      //   formData.append(`files[${i}]`, files[i].raw, files[i].name)
      // }
      // let response = await Upload.upload(formData)
      // console.log(`${this.name}: upload response`, response)
      let response = await SiteAims.upload(file, indata)
      // {
      //   "status": "success",
      //   "name": "1708960821.pdf",
      //   "type": "applicant-resume",
      //   "url": "http:\/\/aims-dev-api.adaptconcepts.com\/upload\/retrieve\/applicant-resume\/1708960821.pdf"
      // }
      const returnData = {
        ...indata,
        ...response,
      }
      if (form.files && form.files.length > 0 && response && response.url) {
        form.files.splice(0, 1, returnData)
      }
      return returnData
    },

    async onSubmit () {
      try {
        this.loading = true
        if (this.jobId == null || isNaN(this.jobId)) {
          throw new Error('invalid job ID')
        }
        await this.validate()
        // console.log('debug form resume', this.formResume)
        // this.loading = false
        // return
        let response

        // form resume
        if (this.formResume.files == null ||
          this.formResume.files.length <= 0) {
          throw new Error('invalid file/(s) for resume')
        }
        response = await this.uploadFile('formResume', -1, Constants.UploadFileType.APPLICANT_RESUME)
        // console.log(`${this.name}: form.submit.files`, files)
        // let files = this.formResume.files
        let filesResume = FileUtil.parse(response)
        // console.log(`${this.name}: form opening response files`, _.cloneDeep(response), _.cloneDeep(filesResume))
        // this.$set(this.formResume, 'files', files)

        // form licenses
        let licenses = []
        for (let lic in this.formLicenses) {
          let formLicense = this.formLicenses[lic]
          if (formLicense.files == null ||
            formLicense.files.length <= 0) {
            throw new Error('invalid file/(s) for license/(s)')
          }
          response = await this.uploadFile('formLicenses', lic, formLicense.type)
          let files = formLicense.files
          files = FileUtil.parse(response)
          formLicense.files = files
          // this.$set(formLicense, 'files', files)
          licenses.push(formLicense)
        }

        // keyinfos
        let keyinfos = OpeningFormConstants.Form.KEYS
        let form = Util.request.parseForm(keyinfos, this.form)
        keyinfos = OpeningFormConstants.FormResume.KEYS
        let formResume = Util.request.parseForm(keyinfos, this.formResume)
        form = _.assign({}, form, formResume)
        console.log(`${this.name}: form.submit.form`, form)

        let refs = []
        for (let f in this.formRefs) {
          let formRef = this.formRefs[f]
          keyinfos = formRef.keys
          formRef = Util.request.parseForm(keyinfos, formRef)
          formRef = _.assign({}, formRef)
          console.log(`${this.name}: form.submit.ref#${f}`, formRef)
          // form = _.assign(form, formRef)
          refs.push(formRef)
        }

        let inform = {
          ...form,
          references: refs,
        }
        console.log(`${this.name}: form.submit`, inform)
        response = await SiteAims.createApplicant(this.jobId, inform)
        if (!response || !response.data || !response.data.id) {
          throw new Error('invalid applicant ID')
        }
        console.log(`${this.name}: form.submit.response`, response)
        let applicantId = response.data.id

        // files resume
        if (filesResume) {
          response = await SiteAims.attachApplicantDocument(applicantId, {
            type: Constants.UploadFileType.APPLICANT_RESUME,
            names: filesResume,
          })
        }

        // files licenses
        if (licenses.length > 0) {
          let promises = []
          let promise
          for (let l in licenses) {
            let licenseInfo = licenses[l]
            let type = licenseInfo.type
            let names = licenseInfo.files
            if (!type) throw new Error('invalid license type')
            promise = SiteAims.attachApplicantDocument(applicantId, {
              type,
              names,
            })
            promises.push(promise)
          }
          await Promise.all(promises)
        }

        this.$alert('Thank you for your interest in Allied Instructional Services. Your resume has successfully been submitted. AIS will contact you with potential next steps.', {
          type: 'success'
        })

        // this.clear()
        // this.setRules()
        //
        // this.load()
        // await this.refresh()
        this.$router.push({ name: 'landing' })

        this.loading = false
      } catch (error) {
        this.loading = false
        this.isValidateError = (error === false)
        if (error === false) {
          let validateErrorSection = this.validateErrorSection
          let anchor = `#top${validateErrorSection ? `-${validateErrorSection}` : ''}`
          this.$scrollTo(anchor)
          return
        }
        this.$set(this, 'error', (error.message || error))
        this.$message({
          message: `Submit failed: ${error.message || error}`,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" src="../../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../../styles/app_setting.scss";

.page-opportunities-form {
  .section-form {
    margin: 36px 24px;
    @media screen and (max-width: $mobile) {
      margin: 24px 18px;
    }
  }
}

</style>
